import React, { useState, useEffect } from "react";
import Lines from "../../components/Lines";
import "./StudyMaterialsUi.scss";
import { AppContext } from "../../context/AppContext";
import { useContext } from "react";

const COURSES = {
  UG: [
    "Part - 1 Language",
    "Part - 2 Language",
    "B.A. English",
    "B.Sc. Computer Science",
    "B.Sc. Information Technology",
    "B.Sc. Biotechnology",
    "B.Sc. Microbiology",
    "B.Sc. Visual Communication",
    "B.Sc. Hotel Management and Catering Science",
    "B.Sc. Nutrition & Dietetics",
    "B.Sc. Mathematics",
    "B.Sc. Chemistry",
    "Bachelor of Computer Applications (BCA)",
    "B.Com.",
    "Bachelor of Business Administration (BBA)",
    "B.Sc. Artificial Intelligence and Data Science",
  ],
  PG: [
    "M.A. English",
    "M.Sc. Biotechnology",
    "M.Com.",
    "M.Sc. Mathematics",
    "M.Sc. Computer Science",
  ],
};

const StudyMaterialsUi = () => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [lineCount, setLineCount] = useState(getResponsiveLineCount());
  const { loading, studyMaterials } = useContext(AppContext);

  useEffect(() => {
    const handleResize = () => {
      setLineCount(getResponsiveLineCount());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    function handleDocumentClick(event) {
      const clickedCourseHeader = event.target.closest(
        ".curriculumCourseHeader"
      );
      const clickedDropdownItem = event.target.closest(
        ".curriculumDropdownItem"
      );
      const clickedDropdownMenu = event.target.closest(
        ".curriculumDropdownMenu"
      );
      if (clickedCourseHeader || clickedDropdownItem || clickedDropdownMenu) {
        return;
      }
      setOpenDropdown(null);
    }

    document.addEventListener("click", handleDocumentClick);
    return () => document.removeEventListener("click", handleDocumentClick);
  }, []);

  function getResponsiveLineCount() {
    const width = window.innerWidth;
    if (width > 1800) return 70;
    if (width > 1700) return 65;
    if (width > 1600) return 60;
    if (width > 1400) return 55;
    if (width > 1300) return 50;
    if (width > 1200) return 50;
    if (width > 1100) return 50;
    if (width > 1000) return 50;
    if (width > 900) return 50;
    return 10;
  }

  const toggleDropdown = (course, e) => {
    if (e) {
      e.stopPropagation();
    }
    setOpenDropdown(openDropdown === course ? null : course);
  };

  const openDocument = (document) => {
    if (!document.data || !document.contentType) return;

    try {
      const byteCharacters = atob(document.data);
      const byteNumbers = Array.from(byteCharacters).map((char) =>
        char.charCodeAt(0)
      );
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: document.contentType });
      const fileUrl = URL.createObjectURL(blob);

      window.open(fileUrl, "_blank", "noopener,noreferrer");
    } catch (error) {
      console.error("Error opening document:", error);
      console.log("Document data length:", document.data?.length);
      console.log("Content type:", document.contentType);
    }
  };

  const hasDocuments = (course) => {
    return studyMaterials[course] && studyMaterials[course].length > 0;
  };

  if (loading) {
    return (
      <section className="curriculumPageMainContainer">
        <header>
          <h2>Study Materials</h2>
        </header>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "200px",
            color: "#116C4A",
            fontSize: "18px",
          }}
        >
          Loading study materials...
        </div>
      </section>
    );
  }

  return (
    <section className="curriculumPageMainContainer">
      <header>
        <h2>Study Materials</h2>
      </header>

      <div className="curriculumPageCoursesParent">
        <article className="curriculumFirstSection">
          <div
            style={{
              width: "fit-content",
              display: "flex",
              flexDirection: "column",
              gap: "30px",
            }}
          >
            <h3>UG Programmes</h3>
            <ul>
              {COURSES["UG"].map((course) => (
                <React.Fragment key={course}>
                  <li
                    className="curriculumCourseItem"
                    style={{ width: "fit-content" }}
                  >
                    <div
                      className={`curriculumCourseHeader ${
                        hasDocuments(course) ? "has-documents" : "no-documents"
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        hasDocuments(course) && toggleDropdown(course, e);
                      }}
                      style={{
                        width: "fit-content",
                        cursor: hasDocuments(course) ? "pointer" : "default",
                      }}
                    >
                      <span>{course}</span>
                      <span className="dropdown-arrow">
                        {hasDocuments(course)
                          ? openDropdown === course
                            ? "▲"
                            : "▼"
                          : null}
                      </span>
                    </div>
                  </li>

                  {hasDocuments(course) && openDropdown === course && (
                    <div
                      className="curriculumDropdownMenu"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {studyMaterials[course].map((doc, index) => (
                        <span
                          key={doc.id}
                          className="curriculumDropdownItem"
                          onClick={(e) => {
                            e.stopPropagation();
                            openDocument(doc);
                          }}
                        >
                          {doc.name}
                        </span>
                      ))}
                    </div>
                  )}
                </React.Fragment>
              ))}
            </ul>
          </div>
        </article>

        <span className="linesParent">
          <Lines
            count={lineCount}
            color="white"
            rotateDeg={90}
            fontSize={2.1}
            spacing={2.5}
            skew={-40}
          />
        </span>

        <article className="curriculumSecondSection">
          <div>
            <h3>PG Programmes</h3>
            <ul>
              {COURSES["PG"].map((course) => (
                <React.Fragment key={course}>
                  <li className="curriculumCourseItem">
                    <div
                      className={`curriculumCourseHeader ${
                        hasDocuments(course) ? "has-documents" : "no-documents"
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        hasDocuments(course) && toggleDropdown(course, e);
                      }}
                      style={{
                        display: "flex",
                        width: "fit-content",
                        cursor: hasDocuments(course) ? "pointer" : "default",
                      }}
                    >
                      <span style={{ width: "fit-content" }}>
                        {course}
                        <span
                          className="dropdown-arrow"
                          style={{ width: "fit-content" }}
                        >
                          {hasDocuments(course)
                            ? openDropdown === course
                              ? "▲"
                              : "▼"
                            : null}
                        </span>
                      </span>
                    </div>
                  </li>

                  {hasDocuments(course) && openDropdown === course && (
                    <div
                      className="curriculumDropdownMenu"
                      style={{ display: "flex", gap: "0px" }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {studyMaterials[course].map((doc, index) => (
                        <span
                          key={doc.id}
                          className="curriculumDropdownItem"
                          onClick={(e) => {
                            e.stopPropagation();
                            openDocument(doc);
                          }}
                        >
                          {doc.name}
                        </span>
                      ))}
                    </div>
                  )}
                </React.Fragment>
              ))}
            </ul>
          </div>
        </article>
      </div>
    </section>
  );
};

export default StudyMaterialsUi;
